import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteConfig } from '@/mocks/data';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteConfig.name,
  url: siteConfig.url,
  description: siteConfig.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteConfig.url}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteConfig.name,
  url: siteConfig.url,
  description: siteConfig.description,
  foundingDate: siteConfig.foundingDate,
  contactPoint: {
    '@type': 'ContactPoint',
    email: siteConfig.contactEmail,
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="看片网站精选推荐——高清免费资源一站直达"
        description="寻找优质看片网站？本页精选全网口碑最佳的看片网站，涵盖高清电影、热门剧集、综艺纪录片，无需注册即可在线观看。速度快、画质清晰、资源更新及时，帮你快速找到最适合的看片网站。"
        keywords="看片网站,免费看片网站推荐,高清看片网站,在线看片网站,好用的看片网站,看片网站大全,热门影视看片网站"
        canonicalUrl={siteConfig.url}
        schema={{ '@graph': [orgSchema, homeSchema] }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <CategorySection />
          <FeaturedSection />
          <CTASection />
          <FAQSection />
        </main>

        <Footer />
      </div>
    </>
  );
}